import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"explicit\"><path id=\".fill .fade\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8V13C16 14.6569 14.6568 16 13 16H8V10.5C8 9.11929 9.11929 8 10.5 8H16Z\"></path><g id=\"Group\"><rect id=\"Rectangle\" x=\"2.75\" y=\"2.75\" width=\"13.0455\" height=\"13.0455\" rx=\"2.25\" stroke-linecap=\"round\"></rect><rect id=\"Rectangle Copy\" x=\"8.20453\" y=\"8.20456\" width=\"13.0455\" height=\"13.0455\" rx=\"2.25\" stroke-linecap=\"round\"></rect></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }